// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"150":"a0bbbe9e","453":"61ed8c34","488":"b030e6c3","555":"58f28b8e","885":"c31dfef9","915":"929ee844"}[chunkId] + ".chunk.js";
};